export default __webpack_public_path__ + "static/media/Mobile.6950a161.svg";